import Step1 from "../pages/AppWizard/Steps/Versions/v1/Step1";
import Step2 from "../pages/AppWizard/Steps/Versions/v1/Step2";
import Step3 from "../pages/AppWizard/Steps/Versions/v1/Step3";
import Step4 from "../pages/AppWizard/Steps/Versions/v1/Step4";
import Step5 from "../pages/AppWizard/Steps/Versions/v1/Step5";
import Step6 from "../pages/AppWizard/Steps/Versions/v1/Step6";
import Step7 from "../pages/AppWizard/Steps/Versions/v1/Step7";
import Step8 from "../pages/AppWizard/Steps/Versions/v1/Step8";

import _ from 'lodash';
import CDBG2021OhioDuplicativeBenefitsForm from "../pages/AppWizard/Steps/Versions/v1/CDBG2021OhioDuplicativeBenefitsForm";
import CovidHardshipReasons from "../pages/AppWizard/Steps/Versions/v1/CovidHardshipReasons";
import Cares2020Step2 from "../pages/AppWizard/Steps/Versions/v1/Cares2020Step2";
import PropertyAddress from "../pages/AppWizard/Steps/Versions/v1/PropertyAddress";
import OregonThirdPartyAgreement from "../pages/AppWizard/Steps/Versions/v1/OregonThirdPartyAgreement";
import OregonDeclarationOfHardship from "../pages/AppWizard/Steps/Versions/v1/OregonDeclarationOfHardship";
import CulJobsApplicantStep from "../pages/AppWizard/Steps/Versions/jobs/cul/1/CulJobsApplicantStep";
import CulJobsIncomeStep from "../pages/AppWizard/Steps/Versions/jobs/cul/1/CulJobsIncomeStep";
import CulJobsHandbookStep from "../pages/AppWizard/Steps/Versions/jobs/cul/1/CulJobsHandbookStep";
import CulJobsBehaviorStep from "../pages/AppWizard/Steps/Versions/jobs/cul/1/CulJobsBehaviorStep";
import CulJobsEmergencyStep from "../pages/AppWizard/Steps/Versions/jobs/cul/1/CulJobsEmergencyStep";
import CulJobsPackageStep from "../pages/AppWizard/Steps/Versions/jobs/cul/1/CulJobsPackageStep";

class ApplicationStepResolver {

    constructor($lang, application) {
        let program = application ? application.program : null;
        let hardshipTitle = $lang('tenant.step_hardship');
        if (program && program.slug === "eraarpa_program")
            hardshipTitle = $lang('tenant.step_hardship_financial');
        this.steps = [
            {
                key: 'addresses',
                title: $lang('tenant.step_property'),
                versions: {
                    1: { component: PropertyAddress, }
                }
            },
            {
                key: 'applicant',
                title: $lang('tenant.step_applicant'),
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/Step1').default },
                    2: { component: require('../pages/AppWizard/Steps/Versions/v2/Step1').default },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/Step1').default },
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/Step1').default },
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/Step1').default },
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/Step1').default },
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/Step1').default },
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/hennepin/Step1").default },
                }
            },
            {
                key: 'ledger-verification',
                title: $lang('tenant.step_assistance'),
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/LedgerVerificationWithNotes').default },
                }

            },
            {
                key: 'property',
                title: $lang('tenant.step_assistance'),
                versions: {
                    1: { component: Step2, },
                    2: { component: require('../pages/AppWizard/Steps/Versions/v2/Step2').default },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/Step2').default },
                    ri: { component: require('../pages/AppWizard/Steps/Versions/ri/Step2').default },
                    oera: { component: require('../pages/AppWizard/Steps/Versions/orera/Step2').default },
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/hennepin/Step2").default },
                }
            },
            {
                key: 'income',
                title: $lang('tenant.step_income'),
                versions: {
                    1: { component: Step3, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/Step3').default, },
                    4: { component: require('../pages/AppWizard/Steps/Versions/v4/Step3').default, },
                    5: { component: require('../pages/AppWizard/Steps/Versions/pathway/Step3').default, },
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/Step3').default, },
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/Step3').default, },
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/hennepin/Step3").default, },
                    clackmas: { component: require('../pages/AppWizard/Steps/Versions/clackmas/Step3').default, },
                }
            },
            {
                key: 'hardship',
                title: $lang('tenant.step_affidavit'),
                versions: {
                    1: { component: Step4, },
                }
            },
            {
                key: 'privacy',
                title: $lang('tenant.step_privacy'),
                versions: {
                    1: { component: Step5, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/PrivacyPolicy').default},
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/PrivacyPolicy').default},
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/PrivacyPolicy').default},
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/PrivacyPolicy').default},
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/PrivacyPolicy').default},
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/PrivacyPolicy').default},
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/PrivacyPolicy').default},
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/PrivacyPolicy').default},
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/PrivacyPolicy').default},
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/PrivacyPolicy').default},
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/hennepin/PrivacyPolicy").default, },
                    delaware: { component: require('../pages/AppWizard/Steps/Versions/delaware/PrivacyPolicy').default},
                }
            },
            {
                key: 'terms-conditions',
                title: $lang('tenant.step_terms'),
                versions: {
                    1: { component: Step6, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/TermsAndConditions').default},
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/TermsAndConditions').default},
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/TermsAndConditions').default},
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/TermsAndConditions').default},
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/TermsAndConditions').default},
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/TermsAndConditions').default},
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/TermsAndConditions').default},
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/TermsAndConditions').default},
                    orera3: { component: require('../pages/AppWizard/Steps/Versions/orera/era3/TermsAndConditions').default},
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/TermsAndConditions').default},
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/TermsAndConditions').default},
                    hennepin: { component:require("../pages/AppWizard/Steps/Versions/hennepin/TermsAndConditions").default, },
                    clackmas: { component: require('../pages/AppWizard/Steps/Versions/clackmas/TermsAndConditions').default},
                    delaware: { component: require('../pages/AppWizard/Steps/Versions/delaware/TermsAndConditions').default},

                }
            },
            {
                key: 'tenant-certification',
                title: 'Applicant Certification',
                versions: {
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/TermsAndConditions').default},
                }
            },
            {
                key: 'tpa',
                title: $lang('tenant.step_release'),
                versions: {
                    1: { component: Step7, },
                    3: { component: require('../pages/AppWizard/Steps/Versions/v3/ThirdPartyAuthorization').default},
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/ThirdPartyAuthorization').default},
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/ThirdPartyAuthorization').default},
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/ThirdPartyAuthorization').default},
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/ThirdPartyAuthorization').default},
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/ThirdPartyAuthorization').default},
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/ThirdPartyAuthorization').default},
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/ThirdPartyAuthorization').default},
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/ThirdPartyAuthorization').default},
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/ThirdPartyAuthorization').default},
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/hennepin/ThirdPartyAuthorization").default, },
                    hennepin2: { component: require("../pages/AppWizard/Steps/Versions/hennepin2/ThirdPartyAuthorization").default, },
                    clackmas: { component: require('../pages/AppWizard/Steps/Versions/clackmas/ThirdPartyAuthorization').default},
                    delaware: { component: require('../pages/AppWizard/Steps/Versions/delaware/ThirdPartyAuthorization').default},
                }
            },
            {
                key: 'documents',
                title: $lang('tenant.step_docs'),
                versions: {
                    1: { component: Step8, },
                    clackmas: { component: require('../pages/AppWizard/Steps/Versions/clackmas/Step8.vue').default},
                }
            },

            {
                key: 'cdbg-duplicative-2021',
                title: $lang('tenant.step_dupe'),
                versions: {
                    1: { component: CDBG2021OhioDuplicativeBenefitsForm, },
                }
            },

            {
                key: 'hardship-reasons',
                title: hardshipTitle,
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/CovidHardshipReasons.vue').default, },
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/CovidHardshipReasons.vue').default },
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/CovidHardshipReasons.vue').default },
                    kera2: { component: require('../pages/AppWizard/Steps/Versions/kera2/CovidHardshipReasonsKera2.vue').default },
                    kera24: { component: require('../pages/AppWizard/Steps/Versions/kera24/CovidHardshipReasonsKera2.vue').default },
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/CovidHardshipReasons.vue').default },
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/CovidHardshipReasons.vue').default },
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/CovidHardshipReasons.vue').default },
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/CovidHardshipReasons.vue').default },
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/CovidHardshipReasons.vue').default },
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/CovidHardshipReasons.vue').default },
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/CovidHardshipReasons.vue').default },
                    uap: { component: require('../pages/AppWizard/Steps/Versions/uap/FinancialHardshipAttestation').default },
                    cols23: { component: require('../pages/AppWizard/Steps/Versions/cols23/CovidHardshipReasons.vue').default },
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/mnera/CovidHardshipReasons.vue").default, },
                    cols24: { component: require('../pages/AppWizard/Steps/Versions/cols24/CovidHardshipReasons.vue').default },
                    clackmas: { component: require('../pages/AppWizard/Steps/Versions/clackmas/FinancialHardshipReasons.vue').default },
                    delaware: { component: require('../pages/AppWizard/Steps/Versions/delaware/CovidHardshipReasons.vue').default },
                }
            },

            {
                key: 'oregon-hardship-declaration',
                title: $lang('tenant.step_declaration'),
                versions: {
                    1: { component: OregonDeclarationOfHardship, },
                }
            },

            {
                key: 'era-duplicative-form',
                title: $lang('tenant.step_dupe'),
                versions: {
                    1: { component: require('../pages/AppWizard/Steps/Versions/v1/DuplicativeBenefitsForm').default },
                    mrap: { component: require('../pages/AppWizard/Steps/Versions/mrap/DuplicativeBenefitsForm').default },
                    kera: { component: require('../pages/AppWizard/Steps/Versions/kera/DuplicativeBenefitsForm').default },
                    merap: { component: require('../pages/AppWizard/Steps/Versions/merap/DuplicativeBenefitsForm').default },
                    ohera: { component: require('../pages/AppWizard/Steps/Versions/ohera/DuplicativeBenefitsForm').default },
                    riera: { component: require('../pages/AppWizard/Steps/Versions/riera/DuplicativeBenefitsForm').default },
                    dera: { component: require('../pages/AppWizard/Steps/Versions/dera/DuplicativeBenefitsForm').default },
                    orera: { component: require('../pages/AppWizard/Steps/Versions/orera/DuplicativeBenefitsForm').default },
                    eraprogram: { component: require('../pages/AppWizard/Steps/Versions/eraprogram/DuplicativeBenefitsForm').default },
                    mnera: { component: require('../pages/AppWizard/Steps/Versions/mnera/DuplicativeBenefitsForm').default },
                    hennepin: { component: require("../pages/AppWizard/Steps/Versions/hennepin/DuplicativeBenefitsForm").default, },
                    delaware: { component: require('../pages/AppWizard/Steps/Versions/delaware/DuplicativeBenefitsForm').default },

                }
            },

            {
                key: 'cdbg-step-2',
                title: $lang('tenant.step_property'),
                versions: {
                    1: { component: Cares2020Step2, },
                }
            },

            {
                key: 'orgeon-tpa',
                title: $lang('tenant.step_tpa'),
                versions: {
                    1: { component: OregonThirdPartyAgreement }
                }
            },

            {
                key: 'jobs-cul-applicant',
                title: $lang('tenant.step_applicant'),
                hideFromStudent: false,
                versions: {
                    1: { component: CulJobsApplicantStep }
                }
            },

            {
                key: 'jobs-cul-income',
                title: $lang('tenant.step_income'),
                hideFromStudent: true,
                versions: {
                    1: { component: CulJobsIncomeStep }
                }
            },

            {
                key: 'job-curl-handbook',
                title: $lang('tenant.step_handbook'),
                hideFromStudent: false,
                versions: {
                    1: { component: CulJobsHandbookStep }
                }
            },

            {
                key: 'job-curl-behavior',
                title: $lang('tenant.step_behavior'),
                hideFromStudent: false,
                versions: {
                    1: { component: CulJobsBehaviorStep }
                }
            },

            {
                key: 'job-curl-emergency',
                title: $lang('tenant.step_emergency'),
                hideFromStudent: true,
                versions: {
                    1: { component: CulJobsEmergencyStep }
                }
            },

            {
                key: 'job-curl-package',
                title: $lang('tenant.step_package'),
                hideFromStudent: false,
                versions: {
                    1: { component: CulJobsPackageStep }
                }
            },

        ];
    }

    getStepTitle(step) {
        let title = ''
        // if (window.hope_lang_function) {
        //     title = window.hope_lang_function(`global.${step.title}`)
        // }
        title = title ? title: step.title;
        const titleCapitalized = title.charAt(0).toUpperCase() + title.slice(1)
        return titleCapitalized
    }

    fromPages(pageKeys, administratorOnlyPageKeys, hasProcessorAccess) {
        let _steps = [];
        _.each(pageKeys, key => {

            if (hasProcessorAccess || !administratorOnlyPageKeys.includes(key)) {

                // Split page key to check for a version
                let _key = key;
                let version = 1;
                let pageKeyArray = key.split('_');
                if (pageKeyArray.length > 1) {
                    _key = pageKeyArray[0];
                    version = pageKeyArray[1];
                }

                _.each(this.steps, step => {

                    if (step.key === _key) {
                        if (step.versions[version] === undefined) {
                            throw 'The step with key "' + _key + '" does not have a version defined for ' + version;
                        }

                        let _step = {
                            key: step.key,
                            title: this.getStepTitle(step),
                            component: step.versions[version].component,
                            hideFromStudent: step.hideFromStudent === undefined ? false : step.hideFromStudent,
                        }
                        _steps.push(_step);
                    }
                })
            }
        })
        return _steps;
    }

    defaultPages() {
        let keys = ["applicant", "property", "income", "hardship", "privacy", "terms-conditions", "tpa", "documents"];
        return this.fromPages(keys);
    }
}

export default ApplicationStepResolver
